import React from "react";
import styled, { css } from "styled-components";
import { Colors } from "../config/Constants";

const Box = ({
  children,
  boxColor = Colors.white,
  boxWidth = "100%",
  boxPadding = "0rem",
  boxBorder,
  overflowHidden,
}) => {
  return (
    <BoxStyled
      boxWidth={boxWidth}
      boxColor={boxColor}
      boxBorder={boxBorder}
      overflowHidden={overflowHidden}
    >
      <ChildrenWrapper boxPadding={boxPadding}>{children}</ChildrenWrapper>
    </BoxStyled>
  );
};

export default Box;

const BoxStyled = styled.div`
  width: ${(props) => props.boxWidth};
  background: ${(props) => props.boxColor};
  border-radius: ${(props) => (props.boxBorder ? props.boxBorder : "0.75rem")};
  ${(props) =>
    props.overflowHidden &&
    css`
      overflow: hidden;
    `}
`;
const ChildrenWrapper = styled.div`
  padding: ${(props) => props.boxPadding};
`;
